import React from 'react';
import Icon from '../../../components/AppIcon';

const SkillTimeline = ({ timelineData }) => {
  return (
    <div className="mb-12">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-text-primary mb-4">Learning Journey</h2>
        <p className="text-lg text-text-secondary max-w-2xl mx-auto">
          My continuous evolution as a developer, highlighting key milestones and technology adoptions.
        </p>
      </div>

      <div className="relative">
        {/* Timeline Line */}
        <div className="absolute left-4 md:left-1/2 transform md:-translate-x-1/2 w-0.5 h-full bg-border"></div>

        <div className="space-y-8">
          {timelineData.map((item, index) => (
            <div
              key={index}
              className={`relative flex items-center ${
                index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
              }`}
            >
              {/* Timeline Dot */}
              <div className={`absolute left-4 md:left-1/2 transform md:-translate-x-1/2 w-8 h-8 rounded-full border-4 border-background flex items-center justify-center z-10 ${
                item.status === 'current' 
                  ? 'bg-accent animate-pulse' 
                  : 'bg-primary'
              }`}>
                <Icon name={item.icon} size={16} color="white" />
              </div>

              {/* Content */}
              <div className={`ml-16 md:ml-0 md:w-1/2 ${
                index % 2 === 0 ? 'md:pr-8' : 'md:pl-8'
              }`}>
                <div className="bg-card rounded-lg border border-border p-6 hover:shadow-md transition-shadow duration-300">
                  <div className="flex items-center justify-between mb-3">
                    <span className={`text-sm font-medium px-3 py-1 rounded-full ${
                      item.status === 'current'
                        ? 'text-accent bg-accent/10'
                        : 'text-primary bg-primary/10'
                    }`}>
                      {item.status === 'current' ? 'Current' : item.year}
                    </span>
                    <span className="text-xs text-text-secondary">
                      {item.duration}
                    </span>
                  </div>
                  
                  <h3 className="text-lg font-semibold text-text-primary mb-2">
                    {item.title}
                  </h3>
                  
                  <p className="text-text-secondary text-sm mb-4">
                    {item.description}
                  </p>

                  {/* Technologies */}
                  <div className="flex flex-wrap gap-2">
                    {item.technologies.map((tech, techIndex) => (
                      <span
                        key={techIndex}
                        className="text-xs bg-muted text-text-secondary px-2 py-1 rounded"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>

                  {/* Achievement */}
                  {item.achievement && (
                    <div className="mt-4 pt-4 border-t border-border">
                      <div className="flex items-center space-x-2">
                        <Icon name="Trophy" size={16} className="text-accent" />
                        <span className="text-sm font-medium text-text-primary">
                          Key Achievement:
                        </span>
                      </div>
                      <p className="text-sm text-text-secondary mt-1">
                        {item.achievement}
                      </p>
                    </div>
                  )}

                  {/* Projects Links */}
                  {item.projects && item.projects.length > 0 && (
                    <div className="mt-4 pt-4 border-t border-border">
                      <div className="flex items-center space-x-2 mb-3">
                        <Icon name="ExternalLink" size={16} className="text-primary" />
                        <span className="text-sm font-medium text-text-primary">
                          Projects:
                        </span>
                      </div>
                      <div className="flex flex-wrap gap-2">
                        {item.projects.map((project, projectIndex) => (
                          <a
                            key={projectIndex}
                            href={project.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center space-x-1 text-xs bg-primary/10 text-primary hover:bg-primary/20 px-3 py-1.5 rounded transition-colors duration-200"
                          >
                            <span>{project.name}</span>
                            <Icon name="ExternalLink" size={12} />
                          </a>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkillTimeline;